import useCustomTranslation from "@/hooks/useTranslation";
import { pxToRem } from "@/util/common";
import { Popup } from "antd-mobile";
import { CloseOutline } from "antd-mobile-icons";
import { createUseStyles } from "react-jss";

const TermsPopup: React.FC<{ visible: boolean; onClose?: () => void }> = (
	props
) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	return (
		<Popup
			bodyStyle={{
				borderTopLeftRadius: pxToRem(20),
				borderTopRightRadius: pxToRem(20),
			}}
			maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
			bodyClassName={classes.popupContent}
			visible={props.visible}
			closeOnMaskClick
			onClose={props.onClose}
		>
			<header className={classes.header}>
				<div onClick={props.onClose}>
					<CloseOutline color="#4c66c7" fontSize={22} />
				</div>
				<h2>{t("TermsConditions")}</h2>
				<div />
			</header>
			<section className={classes.content}>
				<p>
					{t("LoginTips1")} <br />
					<br />
					{t("LoginTips2")}
				</p>
			</section>
		</Popup>
	);
};

export default TermsPopup;

const useStyles = createUseStyles({
	popupContent: {
		backgroundColor: "#1E212A",
		color: "#fff",
	},
	header: {
		borderBottom: "1px solid #2F3A62",
		height: pxToRem(58),
		display: "flex",
		alignItems: "center",
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
		},
		"& div": {
			flex: "none",
			width: "10vw",
			padding: pxToRem(4),
		},
		"& > h2": {
			flex: 1,
			textAlign: "center",
			fontSize: pxToRem(14),
		},
	},
	content: {
		padding: {
			left: pxToRem(24),
			right: pxToRem(24),
			top: pxToRem(20),
			bottom: pxToRem(20),
		},
		fontSize: pxToRem(12),
		lineHeight: pxToRem(18),
	},
});
